import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f55fd54a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f55fd54a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55fd54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f55fd54a')) {
      api.createRecord('f55fd54a', component.options)
    } else {
      api.reload('f55fd54a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f55fd54a&scoped=true", function () {
      api.rerender('f55fd54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/index.vue"
export default component.exports